import { combineReducers } from 'redux';
import Auth from './slices/AuthSlice';
import Member from './slices/MemberSlice';
import Utility from './slices/UtilitySlice';


const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        Auth,
        Member,
        Utility,
        ...asyncReducers,
    });
    return combinedReducer(state, action);
};
  

export default rootReducer;